import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CloseIcon from '@material-ui/icons/Close';
import { calculateAgeParse } from '../../../../Utils/Patient';
import { Modal } from '@material-ui/core';
import pdfFormula from '../../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfFormula';
import pdfProceduresFormat from '../../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfProceduresFormat';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePrescription, faPrescriptionBottleAlt } from "@fortawesome/free-solid-svg-icons";

const OrdensAndMedicinesPatient = ({ id_historia, clinicHistoryByPatient, patient }) => {
    const [ordensAndMedicinesToShow, setOrdensAndMedicinesToShow] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const [eventByAdmission, setEventByAdmission] = useState(null);
    const [showPDf, setShowPDf] = useState(false);
    const [professionals, setProfessionals] = useState(null);
    const urlLogo = sessionStorage.getItem('logoURL');
    const profile = JSON.parse(sessionStorage.getItem('clinica'));

    useEffect(() => {
        const filterInfoToShow = (clinicHistoryComplete) => {
            let infoToShow = [];
            let clinicEvents = clinicHistoryComplete.filter((clinicEvent) => clinicEvent.hasOwnProperty('anamnesis'));
            console.log("soloEventos", clinicEvents);
            clinicEvents.forEach(event_c => {
                if (event_c.tratamiento.ordenes.ordenes.addedDiagnostics.length > 0 || event_c.tratamiento.ordenes.ordenes.formulas.length > 0) {
                    infoToShow.push(event_c);
                }
            });
            setOrdensAndMedicinesToShow(infoToShow);
        }
        if (clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined) {
            filterInfoToShow(clinicHistoryByPatient);
        }
        fetchDataProfessionals();
    }, []);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const searchEventFromClinicHistoryComplete = (id_admision) => {
        let eventClinic = null;
        if (clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined) {
            eventClinic = clinicHistoryByPatient.filter((eventClinic) => eventClinic.id_admision === id_admision)
        }
        setEventByAdmission(eventClinic[0]);
    }

    const fetchDataProfessionals = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
            method: 'GET',
            headers: {
                authorization: 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(professionals => {
                //this.catchProfessional(professionals);
                setProfessionals(professionals);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const catchProfessional = (id_profesional) => {
        let professional = professionals.find((prof) => prof.id_profesional === id_profesional);
        return professional;
    }

    const makePdfFormula = (evento) => {
        let profesional = catchProfessional(evento.id_profesional);
        let infoAdmission = { admision: { id_admision: evento.id_admision, fecha: evento.fecha } }
        const data = {
            from: 'IMP', //Desde donde se consulta la Formula IMP(impresiones/listadoHC o Admisiones) HC desde dentro de Historia Clinica
            today: moment(new Date),
            urlLogo: urlLogo,
            names: patient.nombres + ' ' + patient.apellido1 + ' ' + patient.apellido2,
            ordenes: evento.tratamiento,
            gender: patient.sexo,
            typeOfDocument: patient.tip_documento,
            documentNumber: patient.num_documento,
            profile: profile,
            age: calculateAgeParse(patient.fec_nacimiento),
            day: evento.fecha,
            birthday: patient.fec_nacimiento,
            id_admision: evento.id_admision,
            regime: patient.id_regimen,
            bloodType: patient.tipo_sangre,
            professional: profesional,
            id_historia: evento.id_historia,
            id_profesional: evento.id_profesional,
            third: null,
            infoAdmission: infoAdmission
        };
        setShowPDf(true);
        pdfFormula(data);
    }

    const makePdfProcedure = (evento) => {
        let profesional = catchProfessional(evento.id_profesional);
        let infoAdmission = { admision: { id_admision: evento.id_admision, fecha: evento.fecha } }
        const data = {
            from: 'IMP',
            today: moment(new Date),
            urlLogo: urlLogo,
            names: patient.nombres + ' ' + patient.apellido1 + ' ' + patient.apellido2,
            gender: patient.sexo,
            typeOfDocument: patient.tip_documento,
            documentNumber: patient.num_documento,
            profile: profile,
            age: calculateAgeParse(patient.fec_nacimiento),
            day: evento.fecha,
            birthday: patient.fec_nacimiento,
            regime: patient.id_regimen,
            bloodType: patient.tipo_sangre,
            ordenes: evento.tratamiento,
            professional: profesional,
            id_profesional: evento.id_profesional,
            id_historia: evento.id_historia,
            diagnosticoCie10: evento.diagnostico.diagnostico.diagnostico,
            third: null,
            infoAdmission: infoAdmission
        };
        setShowPDf(true);
        pdfProceduresFormat(data);
    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>ORDENES Y FORMULAS MÉDICAS</b></h4>
                                </div>
                                <div>
                                    <h5>Historia Clínica No. <b>{id_historia}</b></h5>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <Col>
                                {ordensAndMedicinesToShow &&
                                    ordensAndMedicinesToShow.length > 0 &&
                                    ordensAndMedicinesToShow.map((evento_c) => (
                                        <Accordion key={evento_c.id_admision} expanded={expanded === `panel${evento_c.id_admision}`} onChange={handleChange(`panel${evento_c.id_admision}`)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                onClick={() => searchEventFromClinicHistoryComplete(evento_c.id_admision)}
                                                aria-controls={`panel${evento_c.id_admision}-content`}
                                                id={`panel${evento_c.id_admision}-header`}
                                            >
                                                <div className='title-accordion-diagnosis'>
                                                    <LocalHospitalIcon style={{ color: '#55e5bb', marginRight: '0.25em' }} />
                                                    <h5>ADMISIÓN No. <b>{evento_c.id_admision}</b></h5>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className='info-event-admission'>
                                                    {
                                                        eventByAdmission &&
                                                        <Fragment>
                                                            <div className='info-event-admission-row'>
                                                                <div className='event-clinic-tooltip'>
                                                                    <div>
                                                                        <h5>Resumén del Evento Clínico</h5>
                                                                    </div>
                                                                    <div>

                                                                    </div>
                                                                </div>
                                                                <div className='info-event-admission-row-top'>
                                                                    <div>
                                                                        <p><b>Servicio:</b> {eventByAdmission.cita?.servicio?.servicios[0].nombre} </p></div>
                                                                    <div><p><b>Dr.(a):</b>{eventByAdmission.nombres + ' ' + eventByAdmission.apellido1 + ' ' + eventByAdmission.apellido2} </p></div>
                                                                    <div><p><b>Fecha:</b> {moment(eventByAdmission.fecha).format('DD-MM-YYYY')} </p></div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className='container-info-admission'>
                                                                    <div className='container-info-orden-ordenes'>
                                                                        <div className='title-oredenes'>
                                                                            <div>
                                                                                <h4><b>ORDENES MÉDICAS:</b></h4>
                                                                            </div>
                                                                            <div>
                                                                                <Tooltip title="Imprimir Ordenes Médicas">
                                                                                    <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em' }}
                                                                                        disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                                                                        onClick={() => {
                                                                                            //generateClinicEvent(eventByAdmission);
                                                                                            makePdfProcedure(eventByAdmission);
                                                                                        }}
                                                                                    >
                                                                                        {/* <ListAltIcon style={{ color: '#153365', width: '1em', height: '1em' }} /> */}
                                                                                        <FontAwesomeIcon icon={faFilePrescription} style={{ color: '#153365', width: '1em', height: '1em' }} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </div>
                                                                        </div>
                                                                        {evento_c.tratamiento.ordenes.ordenes.addedDiagnostics.length ?
                                                                            evento_c.tratamiento.ordenes.ordenes.addedDiagnostics.map((orden) => (
                                                                                <div key={orden.id} className='container-info-orden-orden'>
                                                                                    <h5>Código CUPS: {orden.cupscod}<b> {orden.cupsnom}</b></h5>
                                                                                </div>
                                                                            ))
                                                                            :
                                                                            <div className='descrip-observation'>
                                                                                <p>No hubo ninguna orden médica generada en esta admisión</p>
                                                                            </div>
                                                                        }
                                                                        <div className='descrip-observation'>
                                                                            <p><b>Observaciones: </b> {evento_c.tratamiento.ordenes.ordenes.observationAndProcedure}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='container-info-orden-medicines'>
                                                                        <div className='title-formulas'>
                                                                            <div>
                                                                                <h4><b>MEDICAMENTOS:</b></h4>
                                                                            </div>
                                                                            <div>
                                                                                <Tooltip title="Imprimir Formula">
                                                                                    <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em', marginRight: '0.25em' }}
                                                                                        disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                                                                        onClick={() => {
                                                                                            //generateClinicEvent(eventByAdmission);
                                                                                            makePdfFormula(eventByAdmission);
                                                                                        }}
                                                                                    >
                                                                                        {/* <ListAltIcon style={{ color: '#153365', width: '1em', height: '1em' }} /> */}
                                                                                        <FontAwesomeIcon icon={faPrescriptionBottleAlt} style={{ color: '#153365', width: '1em', height: '1em' }} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            evento_c.tratamiento.ordenes.ordenes.formulas.length ?
                                                                                evento_c.tratamiento.ordenes.ordenes.formulas.map((formula, i) => (
                                                                                    <div key={i} className='container-info-orden-formula'>
                                                                                        <h5><b>{formula.activePrinciple}</b></h5>
                                                                                        <p><b>Concentración: </b>{formula.concentration} - <b>Forma Farmacéutica: </b>{formula.pharmaceuticalForm} </p>
                                                                                        <p><b>Frecuencia:</b> {formula.frequency} <b>Via de Administración:</b> {formula.frequency} </p>
                                                                                        <p><b>Unidades:</b> {formula.units} <b>Duración:</b> {formula.duration} </p>
                                                                                    </div>
                                                                                ))
                                                                                :
                                                                                <div className='descrip-observation'>
                                                                                    <p>No hubo ninguna Formula generada en esta admisión</p>
                                                                                </div>
                                                                        }
                                                                        <div className='descrip-observation'>
                                                                            <p><b>Observaciones: </b> {evento_c.tratamiento.ordenes.ordenes.medicalObservation}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                    }
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>

            {showPDf ?
                <Modal
                    open={showPDf}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDf(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default OrdensAndMedicinesPatient